// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"error_pageWrapper__QEFui","errorWrapper":"error_errorWrapper__IVxcW","btnWrapper":"error_btnWrapper__p_iZP","logout":"error_logout__GYppV"};